import React, { useEffect, useState } from 'react';
import ScoreBoard from '../feature/scoreBoard/scoreBoard';
import { ref, onValue} from "firebase/database";
import { GameData } from '../models/scoreBoardModels';
import { database } from '../firebase';

const GameStatsPage: React.FC = () => {
    const initialGameData = {
        clock: {
            period: 1,
            fullTime: 0,
            periodTime: 0, 
        },
        home: {
            name: 'Koti',
            score: 0,
            hasPenalty: false,
            penaltyTime: 0,
            timeoutHeld: false,
        },
        away: {
            name: 'Vieras',
            score: 0,
            hasPenalty: false,
            penaltyTime: 0,
            timeoutHeld: false,
        },
    };

    const [ gameData, setGameData ] = useState<GameData>(initialGameData);

    useEffect(() => {
        const starCountRef = ref(database);
        onValue(starCountRef, (snapshot) => {
        const data = snapshot.val();
            setGameData({
                clock: data.clock,
                home: data.home,
                away: data.away,
            })
        });
    }, [])

    return (
        <div>
            <ScoreBoard {...gameData} />
        </div>
    );
};

export default GameStatsPage;
